// removed by extract-text-webpack-plugin
module.exports = {"modale":"modal__modale___3pqjx","panelDatos_heading":"modal__panelDatos_heading___jsm__","tablaDatos":"modal__tablaDatos___22ax2"};


//////////////////
// WEBPACK FOOTER
// ./frontEnd/inventarios/diferencias-inventarios/modal.css
// module id = 1113
// module chunks = 0